import React from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { vehicle as rules } from 'further-ui/validations';
import { z } from 'zod';
import {
  CarriedInterestDayCountFormat,
  PreferredReturnAccrualMethod,
  PreferredReturnBasis,
  PreferredReturnCompoundingPeriod,
} from 'further-types/lp/carry-settings';

export type EqualisationSettingsFormValues = z.infer<
  typeof rules.UpdateEqualisationInterestSettings
>;

type Props = {
  values?: EqualisationSettingsFormValues;
  children: React.ReactNode;
};

const FormWrapper: React.FC<Props> = ({ children, values }) => {
  const formMethods = useForm<EqualisationSettingsFormValues>({
    shouldFocusError: true,
    resolver: zodResolver(rules.UpdateEqualisationInterestSettings),
    defaultValues: {
      dayCount: values?.dayCount ?? CarriedInterestDayCountFormat.ActualActual,
      equalisationInterestFeeTemplates:
        values?.equalisationInterestFeeTemplates &&
        values.equalisationInterestFeeTemplates.length > 0
          ? values.equalisationInterestFeeTemplates
          : [
              {
                name: '',
                equalisationInterestRate: 0,
                equalisationInterestAccrualMethod:
                  PreferredReturnAccrualMethod.Simple,
                equalisationInterestCompoundingPeriod:
                  PreferredReturnCompoundingPeriod.Daily,
                equalisationInterestBasis: PreferredReturnBasis.Drawn,
                isDefault: true,
                isInUse: false,
              },
            ],
    },
    criteriaMode: 'all',
    reValidateMode: 'onChange',
  });

  return <FormProvider {...formMethods}>{children}</FormProvider>;
};

export default FormWrapper;
